import React from "react";
import { FILTER_TYPE_STATIC_SELECT, FILTER_TYPE_STRING } from "../components/SmartTable/methods";
import TableCell from "../components/SmartTable/TableCell";
import UserTableCard from "../pages/Core/Users/UserTableCard";
import ColumnActiveSwitch from "../pages/Organization/OrgSettings/Functions/ColumnActiveSwitch";
import Tooltip from "../components/Tooltip";
import { openModalAction } from "../components/Modal/reducer";
import DeleteItemButton from "../components/SmartTable/TableFiltersActions/DeleteItemButton";
import EntitiesContactColumn from "../pages/Qam/Entities/EntitiesContactColumn";
import { formatString, getActiveFilterOptions } from "./common";

export const generateEntitiesColumns = ({
  tableName,
  modalName,
  permission,
  permissionConstant,
  actionsWidth = 80,
  dispatch,
  trans
}) => {
  return [
    {
      title: "qam.entities.entity",
      dataIndex: "name",
      sorter: true,
      filterType: FILTER_TYPE_STRING,
      width: 200,
      render: (text, row) => (
        <TableCell>
          <UserTableCard
            minWidth={200}
            name={row.name}
            image={row.files[0]?.sizes?.users?.tableImage}
            desc={row.number}
          />
        </TableCell>
      )
    },
    {
      title: "qam.entities.city",
      dataIndex: "city",
      sorter: true,
      filterType: FILTER_TYPE_STRING,
      width: 150,
      render: (text, row) => <TableCell minWidth={150}>{formatString(row.city, "-")}</TableCell>
    },
    {
      title: "qam.entities.address",
      dataIndex: "address",
      filterType: FILTER_TYPE_STRING,
      sorter: true,
      width: 250,
      render: (text, row) => {
        let result = row.address;
        if (result) {
          result = row.address2 ? `${result}, ${row.address2}` : result;
        }
        return <TableCell>{formatString(result, "-")}</TableCell>;
      }
    },
    {
      title: "qam.entities.contact",
      sorter: true,
      dataIndex: "url",
      filterNameKey: "url",
      filterType: FILTER_TYPE_STRING,
      width: 200,
      render: (text, row) => (
        <TableCell minWidth={80}>
          <EntitiesContactColumn row={row} />
        </TableCell>
      )
    },
    {
      title: "container.org_settings.functions_tab.active",
      dataIndex: "active",
      sorter: true,
      filterType: FILTER_TYPE_STATIC_SELECT,
      filterProps: {
        options: getActiveFilterOptions(trans)
      },
      render: (text, row) => (
        <TableCell>
          {trans(row.active ? "container.general_words.active" : "container.general_words.inactive")}
        </TableCell>
      )
    },
    ...(permission.canDo(permissionConstant)
      ? [
          {
            title: trans("container.general_words.actions"),
            fixed: "right",
            width: actionsWidth,
            onCell: () => ({
              style: { right: "-1px" }
            }),
            render: (row = {}) => (
              <div className="table-actions-column">
                <ColumnActiveSwitch
                  className="mr-15"
                  isActive={row.active}
                  route={`qam/entities/change-state/${row.id}`}
                  tooltip={{
                    active: "qam.entities.undo_activate_tooltip",
                    inactive: "qam.entities.activate_tooltip"
                  }}
                />
                <Tooltip title={trans("container.general_words.edit")} placement="top" className="text-primary">
                  <button
                    type="button"
                    className="text-primary"
                    onClick={() => dispatch(openModalAction({ name: modalName, data: row }))}
                    style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
                  >
                    <i className="ti-pencil-alt" />
                  </button>
                </Tooltip>
                <DeleteItemButton
                  disabled={!row.canBeDeleted}
                  tableName={tableName}
                  route={`qam/entities/${row.id}`}
                  content={
                    <div>
                      <div>{trans("container.confirm_modal.form_subtitle")}</div>
                    </div>
                  }
                />
              </div>
            )
          }
        ]
      : [])
  ];
};
